// extracted by mini-css-extract-plugin
module.exports = {"root":"t-gJof","stars":"MppYSS","fill":"Iyp3Me"};